import { css, type SerializedStyles } from '@emotion/react'
import { tooltipClasses } from '@mui/material'
import { type Theme } from '@mui/material/styles'

export const content = (theme: Theme): SerializedStyles =>
  css({
    padding: theme.spacing(3),
    position: 'relative',
  })

export const title = (theme: Theme): SerializedStyles =>
  css({
    paddingBottom: theme.spacing(1),
    whiteSpace: 'pre-line',
  })

export const outline = (theme: Theme): SerializedStyles =>
  css({
    [`& + .${tooltipClasses.popper} > .${tooltipClasses.tooltip}`]: {
      border: `1px solid ${theme.customPalette.onElements.outline}`,
    },
    [`& + .${tooltipClasses.popper} > .${tooltipClasses.tooltip} .${tooltipClasses.arrow}`]: {
      '&::before': {
        border: `1px solid ${theme.customPalette.onElements.outline}`,
      },
    },
  })
